import Box from '@mui/material/Box';
import { UI } from '../../styles/tl5';
import { useGetPageSectionsQuery } from '../../store/siteContentApi';

// The dark claim bar under the contact band.
//
// Six items on one line at desktop, wrapping to as many rows as they need
// below that — the reference lets flex-wrap do all the work rather than
// hiding items at narrow widths, so nothing a visitor might be looking
// for disappears on a phone.
// Fallback — mirrors DEFAULTS.home.trust_strip in pageSectionController.
const CLAIMS = [
  { t: 'NABL accredited, ISO 15189:2022' },
  { t: 'Every report checked by a doctor' },
  { t: 'Same-day report, guaranteed*' },
  { t: 'Vein-finder for pain-free, first-attempt collection' },
  { t: '98.4% EQAS pass rate' },
  // The only star, and the only yellow mark, in the row.
  { t: '4.8 on Google · 1,200+ reviews', mark: '★', color: 'var(--tl-yellow)' },
];

const TrustStrip = () => {
  const { data: sections } = useGetPageSectionsQuery('home');
  const claims = sections?.trust_strip?.claims?.length
    ? sections.trust_strip.claims
    : CLAIMS;

  return (
  <Box component="section" sx={{ width: '100%', maxWidth: 1320, mx: 'auto', pt: 1, px: 2 }}>
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '14px 32px',
        p: '18px 24px',
        borderRadius: '24px',
        bgcolor: 'var(--tl-g9)',
        color: '#FFFFFF',
        fontFamily: UI,
        fontSize: 15,
        fontWeight: 700,
      }}
    >
      {claims.map((c) => (
        <Box key={c.t} component="span" sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Box
            component="span"
            aria-hidden="true"
            sx={{ color: c.color || 'var(--tl-teal-l)', flexShrink: 0 }}
          >
            {c.mark || '✓'}
          </Box>
          {c.t}
        </Box>
      ))}
    </Box>
  </Box>
  );
};

export default TrustStrip;
